export const standardDateFormat = 'YYYY-MM-DD';
export const dateFormatMonths = 'YYYY-MM';
export const dateFormatHours = 'YYYY-MM-DD HH:00';
export const dateFormatHoursAndMins = 'YYYY-MM-DD HH:mm';
export const datePickerLabelformat = 'MMM DD, YYYY';
export const weeksAndYearFormat = 'YYYY WW';
export const calendarHeatmapFormat = 'DD MMM';
